export default __webpack_public_path__ + "gamepad-console.png";